import AppearAnimation from '../../../../utils/AppearAnimation';
import InfiniteScroll from '../../../../utils/InfiniteScroll';

export default class AchievementsPageInit {
    static init() {
        InfiniteScroll.observe();
        InfiniteScroll.livewireRebind();
        AppearAnimation.init();
        AppearAnimation.bindLivewire();

        const moveBlock = () => {
            const frozenContainer = document.querySelector('#frozen-container-achievements');
            const container = document.querySelector('#achievements-container');
            if (container !== null) {
                const achievements = container.children;
                const index = achievements.length;
                for (let i = 0; i < index; i++) {
                    frozenContainer.appendChild(achievements.item(0));
                }
            }
        };

        window.addEventListener('infinite-scroll:loaded', moveBlock);

        moveBlock();
    }
}
